import { Group, Text } from '@mantine/core';

import { MetricHint, type MetricHintKey } from './MetricHint';

export type StatRowProps = {
  label: string;
  value: string | number;
  hint?: MetricHintKey;
};

export function StatRow({ label, value, hint }: StatRowProps) {
  return (
    <Group justify="space-between">
      <Group gap={4}>
        <Text size="sm" c="dimmed">
          {label}
        </Text>
        {hint && <MetricHint hint={hint} />}
      </Group>
      <Text size="sm">{value}</Text>
    </Group>
  );
}
